import type { TOC } from '@ember/component/template-only';
import { eq, or } from 'ember-truth-helpers';
import MarketCustomReportingFormCopyDashboard from 'lumen/components/market/custom-reporting/form/copy-dashboard';
import MarketCustomReportingFormDashboard from 'lumen/components/market/custom-reporting/form/dashboard';
import MarketCustomReportingFormFolder from 'lumen/components/market/custom-reporting/form/folder';
import MarketCustomReportingFormMove from 'lumen/components/market/custom-reporting/form/move';
import MarketCustomReportingFormRemove from 'lumen/components/market/custom-reporting/form/remove';
import MarketCustomReportingSidebar from 'lumen/components/market/custom-reporting/sidebar';
import type MarketCustomReportingController from 'lumen/controllers/market/custom-reporting';

import styles from './custom-reporting.module.css';

interface MarketCustomReportingSignature {
  Args: {
    controller: MarketCustomReportingController;
    model: unknown;
  };
}

<template>
  <div class="{{styles.container}} h-full">
    <div class="{{styles.sidebar}} flex h-full flex-row">
      <MarketCustomReportingSidebar
        @categories={{@controller.categories}}
        @isLoading={{@controller.model.folders.isRunning}}
        @selectedDashboard={{@controller.customReporting.selectedDashboard}}
        @viewOnly={{false}}
      />
      {{outlet}}
    </div>
  </div>

  {{! DASHBOARD ACTION MODALS }}
  {{#if @controller.customReporting.dashboardOperation}}
    {{#let @controller.customReporting.dashboardOperation as |op|}}
      {{#if (or (eq op.type "create") (eq op.type "edit"))}}
        <MarketCustomReportingFormDashboard
          @afterSave={{op.after}}
          @close={{op.close}}
          @dashboard={{op.dashboard}}
        />
      {{/if}}

      {{#if (eq op.type "copy")}}
        <MarketCustomReportingFormCopyDashboard
          @afterCopy={{op.after}}
          @categories={{@controller.categories}}
          @close={{op.close}}
          @dashboard={{op.dashboard}}
        />
      {{/if}}

      {{#if (eq op.type "move")}}
        <MarketCustomReportingFormMove
          @afterMove={{op.after}}
          @categories={{@controller.categories}}
          @close={{op.close}}
          @item={{op.dashboard}}
          @type="dashboard"
        />
      {{/if}}

      {{#if (eq op.type "delete")}}
        <MarketCustomReportingFormRemove
          @afterRemove={{op.after}}
          @close={{op.close}}
          @item={{op.dashboard}}
          @type="dashboard"
        />
      {{/if}}
    {{/let}}
  {{/if}}

  {{! FOLDER ACTION MODALS }}
  {{#if @controller.customReporting.folderOperation}}
    {{#let @controller.customReporting.folderOperation as |op|}}
      {{#if (or (eq op.type "create") (eq op.type "edit"))}}
        <MarketCustomReportingFormFolder
          @close={{op.close}}
          @folder={{op.folder}}
        />
      {{/if}}

      {{#if (eq op.type "move")}}
        <MarketCustomReportingFormMove
          @categories={{@controller.categories}}
          @close={{op.close}}
          @item={{op.folder}}
          @type="folder"
        />
      {{/if}}

      {{#if (eq op.type "delete")}}
        <MarketCustomReportingFormRemove
          @close={{op.close}}
          @item={{op.folder}}
          @type="folder"
        />
      {{/if}}
    {{/let}}
  {{/if}}
</template> satisfies TOC<MarketCustomReportingSignature>;
